import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import { __decorate } from "tslib";
import { Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
var WTooltip = /*#__PURE__*/function (_Vue) {
  function WTooltip() {
    var _this;
    _classCallCheck(this, WTooltip);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, WTooltip, [].concat(args));
    _defineProperty(_this, "content", void 0);
    _defineProperty(_this, "placement", void 0);
    _defineProperty(_this, "effect", void 0);
    return _this;
  }
  _inherits(WTooltip, _Vue);
  return _createClass(WTooltip);
}(Vue);
export { WTooltip as default };
__decorate([Prop({
  default: ""
})], WTooltip.prototype, "content", void 0);
__decorate([Prop({
  default: "bottom"
})], WTooltip.prototype, "placement", void 0);
__decorate([Prop({
  default: "dark"
})], WTooltip.prototype, "effect", void 0);